// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__109vE","title":"styles_title__3JE_i","subtitle":"styles_subtitle__25mCk","button":"styles_button__3keTx"};